import { XMarkIcon } from "@heroicons/react/24/outline";
import { ActionIcon, Badge, rem } from "@mantine/core";

export interface RemovableChipProps {
  /** Text shown on the chip */
  label: string;
  /** Called when the chip's × is clicked */
  onRemove: () => void;
  /** Mantine color key — defaults to the same brand tone `FilterPill`'s tags use */
  color?: string;
}

/**
 * A single removable tag/chip — Badge with an × in its right section. Extracted from
 * `FilterPill`'s inline tag rendering so any "add items, remove individually" UI (e.g. the
 * Reports criteria builder, FS_05_Reporting_01) shares the exact same look instead of a
 * second hand-rolled copy of the same Badge+ActionIcon pattern.
 */
export function RemovableChip({ label, onRemove, color = "sopraPurple" }: RemovableChipProps) {
  return (
    <Badge
      size="sm"
      variant="light"
      color={color}
      pr={2}
      rightSection={
        <ActionIcon
          size={20}
          variant="transparent"
          color={color}
          style={{ pointerEvents: "all" }}
          onClick={(e) => {
            e.stopPropagation();
            onRemove();
          }}
          aria-label={`Remove ${label}`}
        >
          <XMarkIcon style={{ width: rem(13), height: rem(13) }} />
        </ActionIcon>
      }
    >
      {label}
    </Badge>
  );
}
